import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTermsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.TermsDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.TermsDocumentSortInput> | Types.TermsDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetTermsQuery = { __typename?: 'Query', terms?: { __typename?: 'TermsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TermsDocument', id: string, tenantId: string, termsId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus, combinedIntoTermsId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedTermsIds: Array<string>, absorbedNames: Array<string> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTermsByNamesQueryVariables = Types.Exact<{
  where: Types.TermsDocumentFilterInput;
  first: Types.Scalars['Int']['input'];
}>;


export type GetTermsByNamesQuery = { __typename?: 'Query', terms?: { __typename?: 'TermsConnection', totalCount: number, nodes?: Array<{ __typename?: 'TermsDocument', id: string, tenantId: string, termsId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus, combinedIntoTermsId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedTermsIds: Array<string>, absorbedNames: Array<string> }> | null } | null };

export type GetTermsMatchingNamesQueryVariables = Types.Exact<{
  names: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetTermsMatchingNamesQuery = { __typename?: 'Query', termsByNames?: { __typename?: 'TermsByNamesConnection', totalCount: number, nodes?: Array<{ __typename?: 'TermsDocument', name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTermsByIdQueryVariables = Types.Exact<{
  termsId: Types.Scalars['String']['input'];
}>;


export type GetTermsByIdQuery = { __typename?: 'Query', termsById?: { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus } | null };

export type GetTermsCombinePreviewQueryVariables = Types.Exact<{
  survivorId: Types.Scalars['String']['input'];
  loserId: Types.Scalars['String']['input'];
}>;


export type GetTermsCombinePreviewQuery = { __typename?: 'Query', termsCombinePreview: { __typename?: 'TermsCombinePreviewPayload', preview?: { __typename?: 'TermsCombinePreview', survivorId: string, loserId: string, defaultMoves: boolean, conflictCount: number, refusal?: string | null, survivorSuggested: boolean, fields: Array<{ __typename?: 'TermsCombineField', key: string, label: string, kind: Types.TermsCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean }>, survivorUsage: { __typename?: 'TermsCombineUsage', customers: number, shipTos: number, orders: number }, loserUsage: { __typename?: 'TermsCombineUsage', customers: number, shipTos: number, orders: number } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type TermsSummaryFragment = { __typename?: 'TermsDocument', id: string, tenantId: string, termsId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus, combinedIntoTermsId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedTermsIds: Array<string>, absorbedNames: Array<string> };

export type TermsDetailsFragment = { __typename?: 'TermsStateData', id: string, tenantId: string, name: string, termLimitDays: number, accrueInterestPercentage: number, discountDays: number, financeChargeMonthlyRate: number, maximumAnnualFinanceChargeRate: number, isDefault: boolean, status: Types.TermsStatus };

export const TermsSummaryFragmentDoc = new TypedDocumentString(`
    fragment TermsSummary on TermsDocument {
  id
  tenantId
  termsId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
  combinedIntoTermsId
  combinedAt
  combinedBy
  absorbedTermsIds
  absorbedNames
}
    `, {"fragmentName":"TermsSummary"});
export const TermsDetailsFragmentDoc = new TypedDocumentString(`
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}
    `, {"fragmentName":"TermsDetails"});
export const GetTermsDocument = new TypedDocumentString(`
    query GetTerms($where: TermsDocumentFilterInput, $order: [TermsDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  terms(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...TermsSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment TermsSummary on TermsDocument {
  id
  tenantId
  termsId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
  combinedIntoTermsId
  combinedAt
  combinedBy
  absorbedTermsIds
  absorbedNames
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTermsByNamesDocument = new TypedDocumentString(`
    query GetTermsByNames($where: TermsDocumentFilterInput!, $first: Int!) {
  terms(where: $where, first: $first) {
    totalCount
    nodes {
      ...TermsSummary
    }
  }
}
    fragment TermsSummary on TermsDocument {
  id
  tenantId
  termsId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
  combinedIntoTermsId
  combinedAt
  combinedBy
  absorbedTermsIds
  absorbedNames
}`);
export const GetTermsMatchingNamesDocument = new TypedDocumentString(`
    query GetTermsMatchingNames($names: [String!]!, $first: Int, $after: String) {
  termsByNames(names: $names, first: $first, after: $after) {
    nodes {
      name
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetTermsByIdDocument = new TypedDocumentString(`
    query GetTermsById($termsId: String!) {
  termsById(termsId: $termsId) {
    ...TermsDetails
  }
}
    fragment TermsDetails on TermsStateData {
  id
  tenantId
  name
  termLimitDays
  accrueInterestPercentage
  discountDays
  financeChargeMonthlyRate
  maximumAnnualFinanceChargeRate
  isDefault
  status
}`);
export const GetTermsCombinePreviewDocument = new TypedDocumentString(`
    query GetTermsCombinePreview($survivorId: String!, $loserId: String!) {
  termsCombinePreview(survivorId: $survivorId, loserId: $loserId) {
    preview {
      survivorId
      loserId
      fields {
        key
        label
        kind
        survivorValue
        loserValue
        resultValue
        isConflict
      }
      survivorUsage {
        customers
        shipTos
        orders
      }
      loserUsage {
        customers
        shipTos
        orders
      }
      defaultMoves
      conflictCount
      refusal
      survivorSuggested
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTerms: build.query<GetTermsQuery, GetTermsQueryVariables | void>({
      query: (variables) => ({ document: GetTermsDocument, variables })
    }),
    GetTermsByNames: build.query<GetTermsByNamesQuery, GetTermsByNamesQueryVariables>({
      query: (variables) => ({ document: GetTermsByNamesDocument, variables })
    }),
    GetTermsMatchingNames: build.query<GetTermsMatchingNamesQuery, GetTermsMatchingNamesQueryVariables>({
      query: (variables) => ({ document: GetTermsMatchingNamesDocument, variables })
    }),
    GetTermsById: build.query<GetTermsByIdQuery, GetTermsByIdQueryVariables>({
      query: (variables) => ({ document: GetTermsByIdDocument, variables })
    }),
    GetTermsCombinePreview: build.query<GetTermsCombinePreviewQuery, GetTermsCombinePreviewQueryVariables>({
      query: (variables) => ({ document: GetTermsCombinePreviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTermsQuery, useLazyGetTermsQuery, useGetTermsByNamesQuery, useLazyGetTermsByNamesQuery, useGetTermsMatchingNamesQuery, useLazyGetTermsMatchingNamesQuery, useGetTermsByIdQuery, useLazyGetTermsByIdQuery, useGetTermsCombinePreviewQuery, useLazyGetTermsCombinePreviewQuery } = injectedRtkApi;
